import { NodeEnums } from '../const/node';
import { AppNode } from '../types';

/**
 * 根据节点类型，从数据末尾查找，查找最近的节点
 * @returns
 */
export const getLatestNode = (nodes: AppNode[], type: NodeEnums) => {
  for (let i = nodes.length - 1; i >= 0; i--) {
    if (nodes[i]?.type === type) {
      return nodes[i];
    }
  }
  return undefined;
};
